import React, { FC } from 'react';
import { PropsOf, TagButton } from '../../../../../ui';
import { Keyword, KeywordTranslationKeys } from '../../../domain/models';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

type IKeywordButtonProps = PropsOf<typeof TagButton> & {
	keyword?: Keyword;
	disabled?: boolean;
	active?: boolean;
	onClick?: () => void;
};

export const KeywordButton: FC<IKeywordButtonProps> = ({
	keyword,
	...rest
}) => {
	const { t } = useTranslation();

	return (
		<div>
			<TagButton {...rest} aria-current={rest.active}>
				{keyword
					? t(KeywordTranslationKeys[keyword])
					: t('shop_dine_filter_all')}
			</TagButton>
		</div>
	);
};
